import { AfterViewInit, Component, input, ViewChild } from '@angular/core';
import { PdfViewerComponent, PdfViewerModule } from '@syncfusion/ej2-angular-pdfviewer';
import { AuditTrailTransactionNotesReconciliationService } from './audit-trail-transaction-notes-reconciliation.service';

@Component({
  selector: 'eaa-audit-trail-transaction-notes-reconciliation-preview',
  imports: [PdfViewerModule],
  template: `
    <ejs-pdfviewer
      #pdfViewer
      [resourceUrl]="resourceUrl"
      style="height:860px; display: block"
      [enableNavigationToolbar]="false"
      [enablePrint]="true"
      [enableDownload]="true"
    />
  `
})
export class AuditTrailTransactionNotesReconciliationPreviewComponent implements AfterViewInit {
  protected resourceUrl: string;

  public version = input.required<number>();
  public transactionId = input.required<number>();

  @ViewChild('pdfViewer')
  public pdfViewer: PdfViewerComponent | null = null;

  constructor(private service: AuditTrailTransactionNotesReconciliationService) {
    this.resourceUrl = `${window.location.origin}/assets/ej2-pdfviewer-lib`;
  }

  public ngAfterViewInit(): void {
    // Set an extra timeout to allow the assets/ej2-pdfviewer-lib to load
    setTimeout(() => {
      this.service
        .loadTransactionConfirmationPreview$(this.transactionId(), this.version())
        .subscribe((base64Content: string) => this.pdfViewer?.load(base64Content, ''));
    }, 1500);
  }
}
